<template>
    <div>
        <div class="row form-group">
            <label class="col-sm-4 col-form-label text-capitalize text-right">
                รหัสผู้จำหน่าย
            </label>
            <div class="col-sm-6">
                <multiselect
                    v-model="print.vendor"
                    :options="optionVendor"
                    track-by="vendor_id"
                    :customLabel="LabelVendor"
                    :show-labels="false"
                    placeholder="เลือกผู้จำหน่าย">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <label class="col-sm-4 text-right">เลือกประเภทวัตถุดิบ</label>
            <div class="col-sm-6">
                <b-form-select :options="material_type"
                               v-model="print.type">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <label class="col-sm-4 text-right">ช่วงวันที่พิมพ์</label>
            <div class="col-6">
                <date-picker range
                             class="w-100"
                             v-model="print.date"
                             placeholder="วันที่สั่งซื้อ เริ่มต้น - สิ้นสุด"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-primary">
                <icon name="print"></icon>
                พิมพ์
            </button>
            &nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "material-print-report",
    components: {DatePicker, Multiselect},
    created() {
        this.$store.dispatch("Common/getMaterialType");
        this.getVendorAll();
    },
    data() {
        return {
            print: {
                date: [],
                type: "",
                vendor: [],
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionVendor: [],
        }
    },
    computed: {
        ...mapState({
            material_type: state => {
                return [
                    {
                        value: "",
                        text: "เลือกประเภทวัตถุดิบ"
                    },
                    ...state.Common.material_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ]
            },
            form: state => {
                return state.PurchaseOrder.form;
            },
        })
    },
    methods: {
        cancelData() {
            this.$emit("submit", false);
        },
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        submitData() {
            let start_date = "";
            let end_date = "";
            if (this.print.date.length > 0 && this.print.date[0]) {
                start_date = moment(this.print.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.print.date[1]).format("YYYY-MM-DD");
            } else {
                this.print.date = [];
            }
            let data = {
                start_date,
                end_date,
                type: this.print.type,
                vendor_id: this.print.vendor.id ? this.print.vendor.id : '',
            };
            this.$emit("submit", data)
        },
        getVendorAll() {
            this.$store.dispatch("PurchaseOrder/getVendorAll").then(res => {
                this.optionVendor = res;
            });
        },
    }
}
</script>

<style scoped>

</style>
